<p-multiSelect
  [options]="userOptions"
  [(ngModel)]="selectedUserIds"
  optionLabel="name"
  optionValue="id"
  placeholder="Select Users"
  (onChange)="onFilterChange()"
  [showToggleAll]="true"
  [filter]="true"
  [maxSelectedLabels]="1"
  [selectedItemsLabel]="selectedItemsLabel"
  [display]="(selectedUserIds.length >= 4) ? 'comma' : 'chip'"
>
</p-multiSelect>
